import BaseModel from '../BaseModel';

export default class InterviewVideoCategoryVideo extends BaseModel {
  static entity = 'InterviewVideoCategoryVideos';

  static primaryKey = 'id';

  static fields() {
    return {
      id: this.attr(null),
      name: this.attr(null),
      children: this.hasMany(InterviewVideoCategoryVideo, 'parentId', 'id'),
      type: this.string(''),
      parentId: this.number(null),
      depth: this.number(null),
      questions: this.attr([]),
    };
  }

  static apiConfig = {
    actions: {
      async fetchAllByInterviewerId(interviewerId) {
        return this.get(`interviews/interviewers/${interviewerId}/categories`);
      },
    },
  }
}
